import store from '@/stores/store'
import { getAppDisplayName } from '@/appDisplayNames'

const DriverIndication = () => import(/* webpackChunkName: "driver-indication" */ '@/components/driver-indication.vue')
const Index = () => import(/* webpackChunkName: "driver-indication" */ '@/components/driver-indication/Index.vue')
const DetailsView = () => import(/* webpackChunkName: "driver-indication" */ '@/components/driver-indication/DetailsView.vue')

const getAppName = () => getAppDisplayName('driver-indication', store.getters.getPartner)

export default {
  children: [
    {
      component: Index,
      meta: {
        breadcrumbs: [{ dynamicName: getAppName }]
      },
      path: '/'
    },
    {
      component: DetailsView,
      meta: {
        breadcrumbs: [
          { link: '/indicacao-condutores', dynamicName: getAppName },
          { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Detalhes' },
        ]
      },
      path: 'details/:id',
      props: true
    }
  ],
  component: DriverIndication,
  path: 'indicacao-condutores'
}
